import { Box, Typography } from '@mui/material';
import React from 'react';

interface AttachmentsDragOverlayProps {
  visible: boolean;
}

const AttachmentsDragOverlay: React.FC<AttachmentsDragOverlayProps> = ({ visible }) => (
  <Box
    sx={{
      position: 'absolute',
      inset: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: 'action.hover',
      borderRadius: 1,
      opacity: visible ? 1 : 0,
      pointerEvents: visible ? 'auto' : 'none',
      transition: 'opacity 0.2s ease-in-out',
      zIndex: 10,
    }}
  >
    <Typography variant="body1" color="text.secondary">
      Drop your files here
    </Typography>
  </Box>
);

export default AttachmentsDragOverlay;
